export default __webpack_public_path__ + "static/media/WNo.8-10.ec5c869b.jpg";